import {
  CATALOG_SYNC_INTERVAL_MULTIPLIER as STRATEGY_CATALOG_SYNC_INTERVAL_MULTIPLIER,
  CATALOG_SYNC_RETRY_INTERVAL_MS as STRATEGY_CATALOG_SYNC_RETRY_INTERVAL_MS,
  CATALOG_SYNC_SIGNAL_POLL_INTERVAL_MS as STRATEGY_CATALOG_SYNC_SIGNAL_POLL_INTERVAL_MS,
  DAEMON_RUNTIME_CONTRACT_EPOCH as STRATEGY_DAEMON_RUNTIME_CONTRACT_EPOCH,
  DAEMON_STREAM_CONNECT_TIMEOUT_MS as STRATEGY_DAEMON_STREAM_CONNECT_TIMEOUT_MS,
  DAEMON_STREAM_KEEPALIVE_INTERVAL_MS as STRATEGY_DAEMON_STREAM_KEEPALIVE_INTERVAL_MS,
  DAEMON_STREAM_KEEPALIVE_PONG_TIMEOUT_MS as STRATEGY_DAEMON_STREAM_KEEPALIVE_PONG_TIMEOUT_MS,
  DEFAULT_HEARTBEAT_INTERVAL_MS as STRATEGY_DEFAULT_HEARTBEAT_INTERVAL_MS,
  HEARTBEAT_RESPONSE_TIMEOUT_MS as STRATEGY_HEARTBEAT_RESPONSE_TIMEOUT_MS,
  MAX_CATALOG_SYNC_INTERVAL_MS as STRATEGY_MAX_CATALOG_SYNC_INTERVAL_MS,
  MAX_HEARTBEAT_INTERVAL_MS as STRATEGY_MAX_HEARTBEAT_INTERVAL_MS,
  MIN_CATALOG_SYNC_INTERVAL_MS as STRATEGY_MIN_CATALOG_SYNC_INTERVAL_MS,
  MIN_HEARTBEAT_INTERVAL_MS as STRATEGY_MIN_HEARTBEAT_INTERVAL_MS,
  PROVIDER_CONVERSATION_PROOF_SYNC_INTERVAL_MS as STRATEGY_PROVIDER_CONVERSATION_PROOF_SYNC_INTERVAL_MS,
  PROVIDER_CONVERSATION_PROOF_SYNC_RETRY_INTERVAL_MS as STRATEGY_PROVIDER_CONVERSATION_PROOF_SYNC_RETRY_INTERVAL_MS,
  REGISTER_RESPONSE_TIMEOUT_MS as STRATEGY_REGISTER_RESPONSE_TIMEOUT_MS,
  RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_INTERVAL_MS as STRATEGY_RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_INTERVAL_MS,
  RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_RETRY_INTERVAL_MS as STRATEGY_RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_RETRY_INTERVAL_MS,
  RUNTIME_STATE_PERSIST_MIN_INTERVAL_MS as STRATEGY_RUNTIME_STATE_PERSIST_MIN_INTERVAL_MS,
} from "../../strategy-constants";

export const ADAPTIVE_HEARTBEAT_GROWTH_FACTOR = 1.35;
export const ADAPTIVE_HEARTBEAT_JITTER_RATIO = 0.1;
export const CATALOG_SYNC_INTERVAL_MULTIPLIER =
  STRATEGY_CATALOG_SYNC_INTERVAL_MULTIPLIER;
export const CATALOG_SYNC_RETRY_INTERVAL_MS =
  STRATEGY_CATALOG_SYNC_RETRY_INTERVAL_MS;
export const CATALOG_SYNC_SIGNAL_POLL_INTERVAL_MS =
  STRATEGY_CATALOG_SYNC_SIGNAL_POLL_INTERVAL_MS;
export const DAEMON_RUNTIME_CONTRACT_EPOCH =
  STRATEGY_DAEMON_RUNTIME_CONTRACT_EPOCH;
export const DAEMON_STREAM_CONNECT_TIMEOUT_MS =
  STRATEGY_DAEMON_STREAM_CONNECT_TIMEOUT_MS;
export const DAEMON_STREAM_KEEPALIVE_INTERVAL_MS =
  STRATEGY_DAEMON_STREAM_KEEPALIVE_INTERVAL_MS;
export const DAEMON_STREAM_KEEPALIVE_PONG_TIMEOUT_MS =
  STRATEGY_DAEMON_STREAM_KEEPALIVE_PONG_TIMEOUT_MS;
export const DEFAULT_HEARTBEAT_INTERVAL_MS =
  STRATEGY_DEFAULT_HEARTBEAT_INTERVAL_MS;
export const HEARTBEAT_RESPONSE_TIMEOUT_MS =
  STRATEGY_HEARTBEAT_RESPONSE_TIMEOUT_MS;
export const MAX_CATALOG_SYNC_INTERVAL_MS =
  STRATEGY_MAX_CATALOG_SYNC_INTERVAL_MS;
export const MAX_HEARTBEAT_INTERVAL_MS = STRATEGY_MAX_HEARTBEAT_INTERVAL_MS;
export const MIN_CATALOG_SYNC_INTERVAL_MS =
  STRATEGY_MIN_CATALOG_SYNC_INTERVAL_MS;
export const MIN_HEARTBEAT_INTERVAL_MS = STRATEGY_MIN_HEARTBEAT_INTERVAL_MS;
export const PROVIDER_CONVERSATION_PROOF_SYNC_INTERVAL_MS =
  STRATEGY_PROVIDER_CONVERSATION_PROOF_SYNC_INTERVAL_MS;
export const PROVIDER_CONVERSATION_PROOF_SYNC_RETRY_INTERVAL_MS =
  STRATEGY_PROVIDER_CONVERSATION_PROOF_SYNC_RETRY_INTERVAL_MS;
export const REGISTER_RESPONSE_TIMEOUT_MS =
  STRATEGY_REGISTER_RESPONSE_TIMEOUT_MS;
export const RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_INTERVAL_MS =
  STRATEGY_RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_INTERVAL_MS;
export const RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_RETRY_INTERVAL_MS =
  STRATEGY_RUNTIME_AGENT_CONTROLLER_REPORT_SYNC_RETRY_INTERVAL_MS;
export const RUNTIME_STATE_PERSIST_MIN_INTERVAL_MS =
  STRATEGY_RUNTIME_STATE_PERSIST_MIN_INTERVAL_MS;
export const DEFAULT_RECONNECT_DELAY_MS = 1000;
export const MAX_RECONNECT_DELAY_MS = 10_000;
export const HEARTBEAT_CONSECUTIVE_FAILURES_BEFORE_CLOSE = 3;
export const CONTROLLED_SHUTDOWN_RESULT_ACK_TIMEOUT_MS = 5000;
export const CONTROLLED_SHUTDOWN_SOCKET_CLOSE_TIMEOUT_MS = 5000;
export const CONTROLLED_SHUTDOWN_REQUEST_TIMEOUT_MS = 15_000;
export const DAEMON_DEVICE_ID_FILE = "daemon-device-id.txt";
export const CONTEXT_STORE_FILE = "daemon-context-map.json";
export const LEDGER_DIR_NAME = "openMeldDaemon-ledger";
export const DAEMON_RUNTIME_CONTRACT_META_FILE = "runtime-contract-meta.json";
export const DAEMON_RUNTIME_CONTRACT_REPAIR_REPORT_FILE =
  "runtime-contract-repair-report.json";
export const OPENMELD_CLI_NPX_COMMAND = "npx -y openmeld@latest";
export const SPACE_HISTORY_BOOTSTRAP_LIMIT = 200;
export const BOOTSTRAP_INJECTION_KEY_SEPARATOR = "::";
